import PropTypes from 'prop-types';
import React from 'react';
import { getComponentClasses } from '@99designs/utils/app';

class MessageMarker extends React.Component {
    render() {
        var classes = getComponentClasses('message-marker', this.props.variations);
        return (
            <div className={classes}>
                <span className="message-marker__label">{this.props.children}</span>
            </div>
        );
    }
}

MessageMarker.defaultProps = {
    variations: [],
};

MessageMarker.propTypes = {
    children: PropTypes.node.isRequired,
    variations: PropTypes.array,
};

export default MessageMarker;



// WEBPACK FOOTER //
// ./src/web/js/contest/components/message-marker.jsx